export default __webpack_public_path__ + "static/media/logo-webdev.25d88bfc.svg";